import React from "react";
import { Stack } from "@mui/system";
import {
  Typography,
  Button as MuiButton,
  Grid,
} from "@mui/material";
import IconValueVisual from "../visuals/IconValueVisual";
export interface RelatedEventCardProps {
  eventImage?: string;
  eventDate?: string;
  eventName?: string;
  location: string;
  buttonLabel?: string;
}
const RelatedEventCard = ({
  eventImage,
  eventDate,
  eventName,
  location,
  buttonLabel,
}: RelatedEventCardProps) => {
  return (
    <Stack
      height={104}
      border={"2px solid #E7E7E7"}
      display="flex"
      flexDirection="row"
      p={2}
      boxShadow=" 1px 1px 4px 0px rgb(0 0 0 / 25%)"
    >
      <Grid container>
        <Grid item xs={1.5} alignSelf="center">
          {eventImage && <img src={eventImage} width="94px" height="94px" alt="" />}
          {eventDate && (
            <Stack
              alignItems="center"
              justifyContent="center"
              p={2}
              border="1px solid rgba(231, 231, 231, 1)"
              width="71px"
              height="71px"
              textAlign="center"
            >
              <Typography variant="h2" color="primary" fontWeight={400}>
                {eventDate}
              </Typography>
            </Stack>
          )}
        </Grid>
        <Grid item xs={8.5} p={2} display="grid">
          <Typography variant="h2" fontWeight={700}>
            {eventName}
          </Typography>
          <IconValueVisual icon="far fa-map-marker-alt" value={location} />
        </Grid>
        {buttonLabel && (
          <Grid item xs={2} alignSelf="center">
            <MuiButton
              variant="outlined"
              style={{ color: "rgba(177, 210, 56, 1)" }}
            >
              {buttonLabel}
            </MuiButton>
          </Grid>
        )}
      </Grid>
    </Stack>
  );
};

export default RelatedEventCard;
